/* Skin Concierge chat widget — The Clinic Skin Health & Wellness
 *
 * Embed in Shopify (theme.liquid, before </body>):
 *   <script>window.ClinicConcierge = { endpoint: "https://YOUR-WORKER.workers.dev" };</script>
 *   <script src="{{ 'concierge.js' | asset_url }}" defer></script>
 *
 * Brand palette: Shitake #716A5D, Charcoal #2B3033, Stone #E6DFD5, Linen #B4AEA3, Forest #4B5046.
 */
(function () {
  "use strict";

  var config = window.ClinicConcierge || {};
  var ENDPOINT = config.endpoint || "/chat";
  var STORAGE_KEY = "clinic-concierge-transcript";

  var GREETING =
    "Hello, welcome to The Clinic. I'm your Skin Concierge — here to help you understand your skin and find the treatment that suits it best. What's your skin been doing lately?";

  var STARTERS = [
    "Help me choose a treatment",
    "I'm concerned about pigmentation",
    "What happens at a consultation?",
  ];

  var CSS =
    ".cc-root{--cc-shitake:#716A5D;--cc-charcoal:#2B3033;--cc-stone:#E6DFD5;--cc-linen:#B4AEA3;--cc-forest:#4B5046;position:fixed;bottom:24px;right:24px;z-index:2147483000;font-family:Figtree,-apple-system,'Helvetica Neue',sans-serif}" +
    ".cc-btn{display:flex;align-items:center;gap:10px;background:var(--cc-shitake);color:#fff;border:none;border-radius:999px;padding:14px 22px;font-family:inherit;font-size:15px;letter-spacing:.02em;cursor:pointer;box-shadow:0 6px 24px rgba(43,48,51,.25);transition:transform .15s ease,box-shadow .15s ease}" +
    ".cc-btn:hover{transform:translateY(-2px);box-shadow:0 10px 28px rgba(43,48,51,.3)}" +
    ".cc-btn svg{flex:none}" +
    ".cc-panel{display:none;flex-direction:column;position:fixed;bottom:24px;right:24px;width:380px;max-width:calc(100vw - 32px);height:600px;max-height:calc(100vh - 48px);background:#fff;border-radius:16px;box-shadow:0 12px 48px rgba(43,48,51,.3);overflow:hidden}" +
    ".cc-root.cc-open .cc-panel{display:flex}.cc-root.cc-open .cc-btn{display:none}" +
    ".cc-head{background:var(--cc-charcoal);color:var(--cc-stone);padding:18px 20px;display:flex;align-items:center;justify-content:space-between}" +
    ".cc-head h3{margin:0;font-size:16px;font-weight:600;letter-spacing:.05em}" +
    ".cc-head small{display:block;color:var(--cc-linen);font-size:12px;margin-top:2px;letter-spacing:.02em}" +
    ".cc-close{background:none;border:none;color:var(--cc-stone);font-size:22px;line-height:1;cursor:pointer;padding:4px 8px}" +
    ".cc-msgs{flex:1;overflow-y:auto;padding:18px 16px;background:#F7F4EF;display:flex;flex-direction:column;gap:10px}" +
    ".cc-msg{max-width:85%;padding:11px 14px;border-radius:14px;font-size:14px;line-height:1.55;white-space:pre-wrap;word-wrap:break-word}" +
    ".cc-msg.cc-user{align-self:flex-end;background:var(--cc-shitake);color:#fff;border-bottom-right-radius:4px}" +
    ".cc-msg.cc-bot{align-self:flex-start;background:#fff;color:var(--cc-charcoal);border:1px solid var(--cc-stone);border-bottom-left-radius:4px}" +
    ".cc-msg a{color:var(--cc-forest);font-weight:600;text-decoration:underline}" +
    ".cc-msg.cc-user a{color:var(--cc-stone)}" +
    ".cc-typing{align-self:flex-start;padding:12px 16px}.cc-typing span{display:inline-block;width:7px;height:7px;margin:0 2px;background:var(--cc-linen);border-radius:50%;animation:ccb 1.2s infinite}.cc-typing span:nth-child(2){animation-delay:.15s}.cc-typing span:nth-child(3){animation-delay:.3s}" +
    "@keyframes ccb{0%,60%,100%{transform:translateY(0);opacity:.5}30%{transform:translateY(-5px);opacity:1}}" +
    ".cc-starters{display:flex;flex-wrap:wrap;gap:8px;padding:0 16px 10px;background:#F7F4EF}" +
    ".cc-starters button{background:#fff;border:1px solid var(--cc-linen);color:var(--cc-charcoal);border-radius:999px;padding:7px 13px;font-family:inherit;font-size:12.5px;cursor:pointer}" +
    ".cc-starters button:hover{border-color:var(--cc-shitake);color:var(--cc-shitake)}" +
    ".cc-inputrow{display:flex;gap:8px;padding:12px;border-top:1px solid var(--cc-stone);background:#fff}" +
    ".cc-input{flex:1;border:1px solid var(--cc-linen);border-radius:999px;padding:11px 16px;font-family:inherit;font-size:14px;outline:none;color:var(--cc-charcoal)}" +
    ".cc-input:focus{border-color:var(--cc-shitake)}" +
    ".cc-send{background:var(--cc-shitake);color:#fff;border:none;border-radius:999px;width:42px;height:42px;flex:none;cursor:pointer;display:flex;align-items:center;justify-content:center}" +
    ".cc-send:disabled{opacity:.5;cursor:default}" +
    ".cc-note{font-size:10.5px;color:var(--cc-linen);text-align:center;padding:0 12px 10px;background:#fff}" +
    "@media(max-width:480px){.cc-panel{bottom:0;right:0;width:100vw;max-width:100vw;height:100dvh;max-height:100dvh;border-radius:0}}";

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function escapeHtml(s) {
    return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  // Minimal, safe markdown: escape everything, then re-enable [text](https://…), **bold**, bare URLs.
  function render(text) {
    var h = escapeHtml(text);
    h = h.replace(/\[([^\]]+)\]\((https:\/\/[^)\s]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
    h = h.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
    h = h.replace(/(^|[\s(])(https:\/\/[^\s<)]+)/g, '$1<a href="$2" target="_blank" rel="noopener">$2</a>');
    return h;
  }

  function loadTranscript() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }
  function saveTranscript(t) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(t.slice(-24)));
    } catch {}
  }

  var transcript = loadTranscript(); // [{role, content}]
  var busy = false;

  // --- build DOM ---
  var style = document.createElement("style");
  style.textContent = CSS;
  document.head.appendChild(style);

  var root = el("div", "cc-root");
  var btn = el(
    "button",
    "cc-btn",
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M21 11.5a8.38 8.38 0 0 1-8.5 8.5 8.5 8.5 0 0 1-3.8-.9L3 21l1.9-5.7a8.5 8.5 0 1 1 16.1-3.8z"/></svg><span>Skin Concierge</span>'
  );
  btn.setAttribute("aria-label", "Open Skin Concierge chat");

  var panel = el("div", "cc-panel");
  panel.setAttribute("role", "dialog");
  panel.setAttribute("aria-label", "Skin Concierge chat");

  var head = el("div", "cc-head");
  var headText = el("div", null, "<h3>Skin Concierge</h3><small>The Clinic Skin Health &amp; Wellness</small>");
  var closeBtn = el("button", "cc-close", "&times;");
  closeBtn.setAttribute("aria-label", "Close chat");
  head.appendChild(headText);
  head.appendChild(closeBtn);

  var msgs = el("div", "cc-msgs");
  var starters = el("div", "cc-starters");
  var inputRow = el("form", "cc-inputrow");
  var input = el("input", "cc-input");
  input.type = "text";
  input.autocomplete = "off";
  input.placeholder = "Ask about your skin…";
  input.setAttribute("aria-label", "Message");
  var send = el(
    "button",
    "cc-send",
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>'
  );
  send.setAttribute("aria-label", "Send");
  send.type = "submit";
  inputRow.appendChild(input);
  inputRow.appendChild(send);
  var note = el("div", "cc-note", "General guidance only — not medical advice. Your treatment plan is confirmed at consultation.");

  panel.appendChild(head);
  panel.appendChild(msgs);
  panel.appendChild(starters);
  panel.appendChild(inputRow);
  panel.appendChild(note);
  root.appendChild(btn);
  root.appendChild(panel);
  document.body.appendChild(root);

  function addBubble(role, text) {
    var b = el("div", "cc-msg " + (role === "user" ? "cc-user" : "cc-bot"), render(text));
    msgs.appendChild(b);
    msgs.scrollTop = msgs.scrollHeight;
    return b;
  }

  function showStarters(show) {
    starters.style.display = show ? "flex" : "none";
  }

  function repaint() {
    msgs.innerHTML = "";
    addBubble("assistant", GREETING);
    transcript.forEach(function (m) {
      addBubble(m.role, m.content);
    });
    showStarters(transcript.length === 0);
  }

  STARTERS.forEach(function (s) {
    var b = el("button", null, escapeHtml(s));
    b.addEventListener("click", function () {
      submit(s);
    });
    starters.appendChild(b);
  });

  function submit(text) {
    text = (text || "").trim();
    if (!text || busy) return;
    busy = true;
    send.disabled = true;
    showStarters(false);
    input.value = "";

    transcript.push({ role: "user", content: text.slice(0, 2000) });
    saveTranscript(transcript);
    addBubble("user", text);

    var typing = el("div", "cc-msg cc-bot cc-typing", "<span></span><span></span><span></span>");
    msgs.appendChild(typing);
    msgs.scrollTop = msgs.scrollHeight;

    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ messages: transcript.slice(-24) }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        typing.remove();
        var reply = data.reply || "Sorry — something went wrong. Please try again.";
        transcript.push({ role: "assistant", content: reply });
        saveTranscript(transcript);
        addBubble("assistant", reply);
      })
      .catch(function () {
        typing.remove();
        addBubble(
          "assistant",
          "Sorry — I couldn't connect just now. You can always [book a consultation directly](https://theclinicskin.ap.zenoti.com/webstoreNew/services/8ac32655-2221-4513-a424-e659d5c7be3f)."
        );
      })
      .finally(function () {
        busy = false;
        send.disabled = false;
        input.focus();
      });
  }

  btn.addEventListener("click", function () {
    root.classList.add("cc-open");
    repaint();
    input.focus();
  });
  closeBtn.addEventListener("click", function () {
    root.classList.remove("cc-open");
  });
  inputRow.addEventListener("submit", function (e) {
    e.preventDefault();
    submit(input.value);
  });
})();
